/**
 * Number formatting for the portal.
 *
 * Fixed to `en-US` on purpose, and NOT to the interface language. The money is US dollars moving
 * between US brokers, carriers and agencies; a rate confirmation says `$4,500` whether the dispatcher
 * reading it has the portal in English or in Spanish, and re-punctuating it to `4.500 $` would make
 * the screen disagree with the paperwork it is about.
 *
 * Only the numerals are locked. Every word around them comes from the locale files.
 */
const MONEY = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

const MONEY_CENTS = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const COUNT = new Intl.NumberFormat('en-US');

/** `$124,580`. Whole dollars: a ledger total with cents on a KPI tile is noise. */
export function money(value: number): string {
  return MONEY.format(value);
}

/** `$3.75`. Rates per mile are quoted to the cent and the cent is the whole point. */
export function moneyCents(value: number): string {
  return MONEY_CENTS.format(value);
}

/** `1,350`. Miles and counts. */
export function count(value: number): string {
  return COUNT.format(value);
}

/** `$48K`, for a bar label where the exact dollar would not fit and would not be read. */
export function moneyCompact(value: number): string {
  return `${MONEY.format(Math.round(value / 1000))}K`;
}
